import React from "react";
import AdminDashboardLeft from "../../Admin/dashboard-left";
import AdminDashboardRight from "../../Admin/dashboard-right";
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    container: {
        display: 'flex',
        padding: "20px"
    }
});

interface Props {
    children: any;
}

const SampleAccessioningDash: React.FC<Props> = ({ children }) => {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <AdminDashboardLeft />
            <AdminDashboardRight>{children && children}</AdminDashboardRight>
        </div>
    );
};

export default SampleAccessioningDash;

